

export const Images = () => {
    return (<>
        <div className="grids-img">
            <img src="/assets/images/projects/3.2.png" alt="" className="projects-img" />
            <img src="/assets/images/projects/3.3.png" alt="" className="projects-img" />
            <img src="/assets/images/projects/3.4.png" alt="" className="projects-img" />
            <img src="/assets/images/projects/3.5.png" alt="" className="projects-img" />
        </div>
    </>)
}